export class Darujme {

    static init() {
        var $ = jQuery;
        const $form = Darujme._getForm();

        if (!$form.length === 0) {
            return
        }

        // Init functions
        Darujme._togglePaymentMethods();

        // Register events
        $form.find('input[name="frequency"]').on('change', function (e) {
            Darujme._togglePaymentMethods();
        });

        // On amount value change
        document.querySelectorAll('input[name="amount_radio"]').forEach(function (element) {
            element.addEventListener('change', function() {
                const $input = $(element);
                const $listItem = $input.closest('.form-amount-list-item');

                // Unselected other list items
                $('.form-amount-list-item')
                    .removeClass('is-selected')
                    .removeClass('is-focused');
                //
                $listItem.addClass('is-selected');
                $listItem.addClass('is-focused');

                // If user select custom amount we focus input
                if($listItem.find('.form-input-custom-amount').length > 0) {
                    $listItem.find('.form-input-custom-amount input').focus();
                }
            })
        });

        $('.form-input-custom-amount input').on('focusout', function(e) {
            const $parent = $(this).closest('.form-input-custom-amount');
            const $amount = $parent.find('.filled-amount');
            const $listItem = $(this).closest('.form-amount-list-item');

            $($amount).text(Number($(this).val()) + ' Kč');
            $listItem.removeClass('is-focused');
        })

        $('.form-input-custom-amount').on('click', function() {
            const $listItem = $(this).closest('.form-amount-list-item');
            const $input = $(this).find('input');

            $listItem.addClass('is-focused');
            $input.focus();
        })
    }

    // ------------------------------------------- Payment methods ------------------------------------------ \\

    /**
     * Show, hide available epayment methods
     *
     * @private
     */
    static _togglePaymentMethods() {
        const $ = jQuery;
        const $form = Darujme._getForm();
        //

        // Loop over all payment methods
        $form.find('input[name="paymentMethod"]').each(function (index, element) {
            const $input = $(element);
            const $col = $input.closest('.payment-method-col');
            const value = $input.val();

            if (!Darujme._isPaymentMethodAvailable(value)) {
                $col.hide();
            } else {
                $col.show();
            }
        });
    }

    /**
     * Check if payment method is available
     *
     * @param {string} value Payment method form value
     * @return {boolean}
     * @private
     */
    static _isPaymentMethodAvailable(value) {
        switch (value) {
            // Apple Pay
            case 'apple_pay_charge':
                // Show only for iOS and mac
                if (!Darujme._isApplePayAvailable()) {
                    return false;
                }

                // Show only for once frequency
                if (Darujme._isMonthlyDonate()) {
                    return false;
                }

                return true;
            // Google Pay
            case 'gpay_charge':
                // Show only for once frequency
                if (Darujme._isMonthlyDonate()) {
                    return false;
                }

                return true;
            // Bank Payment
            case 'funds_transfer':
                return true;
            // Card Payment
            case 'proxypay_charge':
                return true;
        }
    }

    /**
     * Check if current browser support Apple Pay
     *
     * @returns {boolean}
     * @private
     */
    static _isApplePayAvailable() {
        if (window.ApplePaySession) {
            return true;
        } else {
            return false;
        }
    }

    // ----------------------------------------- Other helpers ------------------------------------------- \\

    /**
     *
     * @private
     * @return jQuery
     */
    static _getForm() {
        const $ = jQuery;

        return $('#support-form');
    }

    /**
     * Check if user has select monthly/recurring donate
     *
     * @return {boolean}
     */
    static _isMonthlyDonate() {
        const $form = Darujme._getForm();

        if ($form.find('[name="frequency"]:checked').val() === 'monthly') {
            return true;
        } else {
            return false;
        }
    }
}